import { Loader2, Globe, AlertTriangle } from "lucide-react";

export function DomainLoading() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center" data-testid="domain-loading">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="w-6 h-6 animate-spin text-white/60" />
        <p className="text-xs uppercase tracking-[0.3em] text-white/40">Loading…</p>
      </div>
    </div>
  );
}

export function DomainNotConnected({ host }) {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-6" data-testid="domain-not-connected">
      <div className="max-w-md w-full border border-white/10 bg-white/[0.02] p-8">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 border border-white/15 flex items-center justify-center">
            <Globe className="w-5 h-5 text-white/70" />
          </div>
          <div>
            <h1 className="font-display text-lg font-bold tracking-tight">Domain not connected</h1>
            <p className="text-xs uppercase tracking-[0.25em] text-white/40 mt-1">{host || "this domain"}</p>
          </div>
        </div>
        <div className="flex items-start gap-2 text-sm text-white/60 leading-relaxed">
          <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0 text-amber-400" />
          <p>
            This domain isn&apos;t linked to a live storefront yet. If you&apos;re the studio owner,
            open your <span className="text-white">Studio Console → Domains</span> and finish
            connecting &amp; verifying this domain.
          </p>
        </div>
      </div>
    </div>
  );
}
